import PropTypes from 'prop-types';
import {
  ItemContainer,
  ItemDetails,
  ItemImage,
  ItemName,
  ItemDescription,
  RemoveItemIcon,
  ItemWrapper,
} from './AddPharmacyModal.style';

const DoctorRecord = ({ key, image, name, address, removeItem }) => (
  <ItemContainer key={key}>
    <ItemWrapper isEdit>
      <ItemWrapper
        style={{
          height: '40px',
        }}
      >
        <RemoveItemIcon
          onClick={() => {
            removeItem();
          }}
        />
        <ItemImage src={image} alt="dr-image" />
        <ItemDetails>
          <ItemName>{name}</ItemName>
          <ItemDescription>{address}</ItemDescription>
        </ItemDetails>
      </ItemWrapper>
    </ItemWrapper>
  </ItemContainer>
);

DoctorRecord.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  address: PropTypes.string,
  removeItem: PropTypes.func,
};

export default DoctorRecord;
